import { useEffect } from 'react';
import { Building2, Briefcase } from 'lucide-react';
import { OnboardingStepLayout } from 'components';

const OnboardingUserTypeStep = ({ value, onChange, onValidation }) => {
  useEffect(() => {
    onValidation?.(Boolean(value));
  }, [value, onValidation]);

  const handleSelect = (type) => {
    if (type !== value) onChange?.(type);
  };

  return (
    <OnboardingStepLayout
      title="¿Qué describe mejor lo que hacés?"
      subtitle="Seleccioná la opción que mejor represente tu caso para personalizar tu experiencia."
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <button
          type="button"
          onClick={() => handleSelect('agencia')}
          className={`group flex flex-col items-center justify-center p-6 rounded-2xl border-2 transition-all duration-200 ${
            value === 'agencia'
              ? 'border-blue-500 bg-blue-50 shadow-md'
              : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
          }`}
        >
          <div className={`w-14 h-14 rounded-full flex items-center justify-center mb-3 ${
            value === 'agencia' ? 'bg-blue-100' : 'bg-gray-100 group-hover:bg-gray-200'
          }`}>
            <Building2 className={`w-7 h-7 ${value === 'agencia' ? 'text-blue-600' : 'text-gray-600'}`} />
          </div>
          <span className="font-semibold text-lg text-gray-900">Agencia</span>
          <span className="text-sm text-gray-600 mt-1 text-center">Represento a varios clientes</span>
        </button>

        <button
          type="button"
          onClick={() => handleSelect('negocio')}
          className={`group flex flex-col items-center justify-center p-6 rounded-2xl border-2 transition-all duration-200 ${
            value === 'negocio'
              ? 'border-blue-500 bg-blue-50 shadow-md'
              : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
          }`}
        >
          <div className={`w-14 h-14 rounded-full flex items-center justify-center mb-3 ${
            value === 'negocio' ? 'bg-blue-100' : 'bg-gray-100 group-hover:bg-gray-200'
          }`}>
            <Briefcase className={`w-7 h-7 ${value === 'negocio' ? 'text-blue-600' : 'text-gray-600'}`} />
          </div>
          <span className="font-semibold text-lg text-gray-900">Negocio</span>
          <span className="text-sm text-gray-600 mt-1 text-center">Tengo mi propio negocio</span>
        </button>
      </div>
    </OnboardingStepLayout>
  );
};

export default OnboardingUserTypeStep;
